import React from 'react'
import { Button, Space, theme } from 'antd'
import { SaveOutlined } from '@ant-design/icons'

type SortOrderActionBarProps = {
  isDirty: boolean
  loading: boolean
  isMobile: boolean
  onCancel: () => void
  onSave: () => void
}

const SortOrderActionBar: React.FC<SortOrderActionBarProps> = ({
  isDirty,
  loading,
  isMobile,
  onCancel,
  onSave,
}) => {
  const { token } = theme.useToken()

  const barStyle: React.CSSProperties = isMobile
    ? {
        position: 'sticky',
        bottom: 0,
        backgroundColor: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
        padding: '12px 16px',
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 10,
        marginTop: 8,
      }
    : {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 16,
        paddingTop: 12,
        borderTop: `1px solid ${token.colorBorderSecondary}`,
      }

  return (
    <div style={barStyle}>
      <Space>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          disabled={!isDirty}
          loading={loading}
          onClick={onSave}
        >
          Save Order
        </Button>
      </Space>
    </div>
  )
}

export default SortOrderActionBar
